import React from 'react';
import './about_us.css';

function AboutUs() {
  return (
    <div className="about-us-container">
      <h2>About Us</h2>
      <p>
      The Institute for Electrical and Electronics Engineers (IEEE) inspires wisdom and knowledge within technology. The BMSCE IEEE Student Branch, founded in 2009 under Dr. Ravishankar Deekshit with Ashwith Jerome Rego as the first chairperson, has grown over 14 years to become the 10th largest Student Branch globally and the 4th largest in the Bangalore Section. 
      </p><br></br>
      <p>
      Through year-round webinars, workshops, SIGs, and competitions, BMSCE IEEE Student Branch keeps members engaged and informed about advancements in the tech world. Recent accolades, such as the IEEE Regional Exemplary Student Branch Award 2022 and the Outstanding Large Student Branch Award 2022, affirm its position as a leading technical society at BMSCE.
      </p>
    </div>
  );
}

export default AboutUs;